import {
  EventNames,
  TrackingEvent,
  TrackingEventTypes,
} from '@cinch-nx/shared-analytics'

export interface HandleTrackingClickArgs {
  label: string
  category: string
  eventName: string
}

export const handleTrackingClick = (
  trackEvent: (event: TrackingEvent) => void,
  data: HandleTrackingClickArgs,
) => {
  trackEvent({
    eventName: data.eventName,
    type: TrackingEventTypes.ADOBE,
    data: {
      event: {
        name: EventNames.click,
        category: data.category,
        label: data.label,
        action: EventNames.click,
      },
    },
  })
}
